/**
 * Цвет буквенной плашки по категории справочника.
 *
 * Не из палитры приложения намеренно: это ось СМЫСЛА (язык / фреймворк /
 * облако), а не акцент интерфейса, и она обязана читаться одинаково в обоих
 * фронтах и в обеих темах — поэтому цвета литеральные и тему не переворачивают
 * (буква на плашке всегда белая, контраст держится в любой).
 *
 * 🔴 Отдельным файлом, а не внутри `SkillIcon`: ту же плашку рисует карта
 * навыков — там знак идёт прямым SVG, без React-компонента (см.
 * `CareerSkillMap/parts/SkillGlyph`). Скопированная карта разъехалась бы на
 * первой же новой категории, и «язык» в списке отличался бы от «языка» на
 * карте цветом.
 */
export const CATEGORY_COLORS: Record<string, string> = {
  language: '#3E63DD',
  framework: '#7C3AED',
  library: '#0891B2',
  tool: '#475569',
  database: '#047857',
  cloud: '#B45309',
  domain: '#BE185D',
  soft: '#C2410C',
};

/** Категории нет или она незнакомая — нейтральный шифер. */
export const FALLBACK_COLOR = '#64748B';
